import { useEffect } from 'react';

/**
 * Cross-tab sync disabled: sessionStorage is tab-isolated.
 * Each tab maintains its own independent session.
 * No cross-tab synchronization needed.
 */
export const useCrossTabSync = () => {
  useEffect(() => {
    // No-op: sessionStorage doesn't support cross-tab events
    return () => {};
  }, []);
};
